module.exports = __webpack_public_path__ + "static/media/logo192x192.353340bf.png";